var map = {
	"./ache-mark-munzel.jpg": 69,
	"./afro-latin-america-george-reid-andrews.jpg": 70,
	"./afro-latinos-in-movement-petra-rivera.jpg": 71,
	"./beyond-the-fantastic-various.jpg": 72,
	"./caudillos-hugh-hamill.jpg": 73,
	"./chronicles-of-the-guayaki-indians-pierre-clastres.jpg": 74,
	"./forgotten-fatherland-ben-macintyre.jpg": 75,
	"./guarani-purahei-lopez-martin.jpg": 76,
	"./latin-america-political-economy-javier-santiso.jpg": 77,
	"./latin-american-posters-davidson.jpg": 78,
	"./mobility-of-modernism-harper-montgomery.jpg": 79,
	"./modern-architecture-luis-carranza.jpg": 80,
	"./moving-chairs-pandora-jane-knocker.png": 81,
	"./open-veins-eduardo-galeano.jpg": 82,
	"./radical-women-cecilia-f-hill.jpg": 83,
	"./simon-bolivar-john-lynch.jpg": 84,
	"./the-paraguay-reader-nickson-lambert.jpg": 85,
	"./the-three-amigos-deborah-shaw.jpg": 86,
	"./travels-with-my-aunt-graham-greene.jpg": 87,
	"./yemoga-solimar-otero.jpg": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;